<div class="o-grid">
	<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
		<div class="o-grid o-grid--fs o-grid--column">
			<div class="o-grid__cell o-grid__cell--flex o-grid__cell--w-fit o-grid__cell--center-h u-no-p" style="position:relative">
				<video id="remoteVideo" style="position:absolute;width:100%;height:100%;" autoplay muted playsinline [hidden]="!vm.callSettings?.remoteVideoEnabled"></video>
				<div *ngIf="vm.setupStatus?.visible" [ngStyle]="{'color': vm.setupStatus?.isError ? '#ff6b6b' : '#fff'}" style="position:fixed;top:12px;right:12px;z-index:10001;max-width:400px;width:calc(100% - 24px);background-color:rgba(0,0,0,.7);border-radius:4px;padding:10px 12px;box-shadow:0 4px 18px rgba(0,0,0,.25);text-align:left;overflow-wrap:anywhere;white-space:normal;">
					<div style="font-size:13px;line-height:18px;font-weight:600;">{{ vm.setupStatus.message }}</div>
					<div *ngIf="vm.setupStatus.detail" [ngStyle]="{'color': vm.setupStatus?.isError ? '#ffb3b3' : '#fff'}" style="font-size:12px;line-height:17px;opacity:.82;margin-top:2px;">{{ vm.setupStatus.detail }}</div>
				</div>
				<div *ngIf="vm.devicesMissing" class="o-grid" [ngClass]="{'u-ost-xxl u-no-m@md-and-up': vm.activeCallState==vm.callState?.STARTED}" style="position:absolute;top:0;left:0;z-index:10000">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-ost-md">
						<item-notification icon="attention" [theme]="6" [text]="vm.devicesMissingText"></item-notification>
					</div>
				</div>
				<div class="o-grid o-grid--center-h o-grid--column" *ngIf="!vm.callSettings?.remoteVideoEnabled">
					<div class="o-grid__cell">
						<div class="u-hidden@md-and-up u-ost-sm" *ngIf="vm.activeCallState==vm.callState?.STARTED">
							<p class="c-text c-text--bold c-text--s4" *ngIf="vm.endpointUser?.firstName">{{vm.endpointUser?.firstName + ' ' + vm.endpointUser?.lastName}}</p>
							<p class="c-text c-text--s4">{{ vm.formattedTimer }}</p>
						</div>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v o-grid__cell--center-h">
						<div class="c-image c-image--bg c-image--round c-image--xl" [ngStyle]="{ 'background-image': 'url(' + (vm.endpointUser?.photoUrl ? vm.endpointUser?.photoUrl : vm.defaultProfilePicture) + ')' }"></div>
						<div class="u-ost-xl u-osb-md">
							<p class="c-text c-text--s4" *ngIf="vm.activeCallState === vm.callState?.CALLING">{{ "Call.Title.Calling" | translate }}</p>
							<p class="c-text c-text--s4" *ngIf="vm.activeCallState === vm.callState?.ENDED">{{ vm.callEndedReason }}. <button class="c-button c-button--link c-text c-text--s4" (click)="vm.closeWindow()">{{ 'Call.Button.Close_Window' | translate }}</button></p>
						</div>
						<p class="c-text c-text--s4 c-text--bold c-text--lg" *ngIf="vm.activeCallState !== vm.callState?.STARTED && vm.endpointUser">{{vm.endpointUser?.firstName + ' ' + vm.endpointUser?.lastName}}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--flex">
						<div class="c-content c-content--xxl c-content--footer" *ngIf="vm.notification?.isVisible">
							<div class="o-container">
								<div class="o-grid o-grid--center-h">
									<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
										<item-notification icon="{{vm.notification.icon}}" [theme]="4" [text]="vm.notification.text" [btnText]="vm.notification.btnText" [action]="vm.notification.action"></item-notification>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="c-card c-card--elevated c-card--persistent c-card--preview u-no-scroll">
					<video id="localVideo" autoplay playsinline [hidden]="!vm.callSettings?.localVideoEnabled"></video>
					<i id="localNetworkStatus" class="o-icon o-icon--signal-0 u-hidden@up-to-md" aria-hidden="true" style="visibility:hidden;position:absolute;top:10px;left:10px;font-size:38px"></i>
				</div>
			</div>
			<div class="c-card c-card--s1 c-card--flat" style="position:fixed;bottom:0;width:100%;">
				<div class="c-content">
					<div class="o-grid o-grid--center-v o-grid--center-h">
						<div class="o-grid__cell u-no-p u-hidden@up-to-md">
							<div *ngIf="vm.activeCallState==vm.callState?.STARTED">
								<div style="display:inline-block;vertical-align:top;">
									<i id="remoteNetworkStatus" class="o-icon o-icon--signal-0" aria-hidden="true" style="visibility:hidden;font-size:43px"></i>
								</div>
								<div style="display:inline-block;padding-top:3px;">
									<p class="c-text c-text--sm c-text--bold c-text--s4">{{vm.endpointUser?.firstName + ' ' + vm.endpointUser?.lastName}}</p>
									<p class="c-text c-text--sm c-text--s4">{{ vm.formattedTimer }}</p>
								</div>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@sm-and-up u-ost-sm u-osb-sm">
							<div class="o-grid">
							    <div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h" *ngIf="!vm.sharingDisabled && !vm.callSettings?.localVideoEnabled">
                                    <button title="Screen sharing disabled" class="c-button c-button--s1 c-button--icon c-button--round c-button--disabled">
                                        <i class="o-icon o-icon--screen u-no-mr" aria-hidden="true"></i>
                                    </button>
                                </div>
							    <div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h" *ngIf="vm.screenSharing && vm.callSettings?.localVideoEnabled">
                                    <button title="Stop screen sharing" class="c-button c-button--s8 c-button--icon c-button--round" (click)="vm.stopShareScreen()">
                                        <i class="o-icon o-icon--screen u-no-mr" aria-hidden="true"></i>
                                    </button>
                                </div>
							    <div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h" *ngIf="!vm.sharingDisabled && !vm.screenSharing && vm.activeCallState==vm.callState?.STARTED && vm.callSettings?.localVideoEnabled">
                                    <button title="Screen sharing" class="c-button c-button--s1 c-button--icon c-button--round" (click)="vm.shareScreen()">
                                        <i class="o-icon o-icon--screen u-no-mr" aria-hidden="true"></i>
                                    </button>
                                </div>
								<div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h" *ngIf="vm.videoDevices?.length > 1 && vm.activeCallState==vm.callState?.STARTED && vm.callSettings?.localVideoEnabled">
									<button title="Switch camera" class="c-button c-button--s1 c-button--icon c-button--round" (click)="vm.handleCameraSwitch()">
										<i class="o-icon o-icon--camera-flip u-no-mr" aria-hidden="true"></i>
									</button>
								</div>
								<div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h" *ngIf="!vm.audioOnly">
									<button title="Toggle camera on/off" class="c-button c-button--s1 c-button--icon c-button--round" (click)="vm.toggleVideo()">
										<i class="o-icon o-icon--video u-no-mr" aria-hidden="true"></i>
										<span class="o-icon-disabled" *ngIf="!vm.callSettings?.localVideoEnabled"></span>
									</button>
								</div>
								<div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h">
									<button title="Toggle mic on/off" class="c-button c-button--s1 c-button--icon c-button--round" (click)="vm.toggleMic()">
										<i class="o-icon u-no-mr" [ngClass]="{'o-icon--mic': vm.callSettings?.localAudioEnabled, 'o-icon--mic-mute': !vm.callSettings?.localAudioEnabled}" aria-hidden="true"></i>
									</button>
								</div>
								<div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h">
									<button title="Toggle speaker on/off" class="c-button c-button--s1 c-button--icon c-button--round" (click)="vm.toggleSound()">
										<i class="o-icon u-no-mr" [ngClass]="{'o-icon--sound': vm.callSettings?.remoteAudioEnabled, 'o-icon--mute': !vm.callSettings?.remoteAudioEnabled}" aria-hidden="true"></i>
									</button>
								</div>
								<div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h">
									<button title="Chat" class="c-button c-button--s1 c-button--icon c-button--round" (click)="vm.toggleChat()">
										<i class="o-icon o-icon--chat u-no-mr" aria-hidden="true"></i>
										<span class="c-badge c-badge--s2 c-badge--sm" style="position:absolute;right:-6px;top:0;" *ngIf="vm.chat?.unread"></span>
									</button>
								</div>
								<div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h" *ngIf="vm.isDoctor">
									<button class="c-button c-button--s1 c-button--icon c-button--round" [ngClass]="{'c-button--disabled': !vm.notesAllowed}" (click)="vm.toggleNotes()" title="{{ !vm.notesAllowed ? ('Services.Other.Notes_Disabled' | translate) : '' }}">
										<i class="o-icon o-icon--notes u-no-mr" aria-hidden="true"></i>
									</button>
								</div>
								<div class="o-grid__cell o-grid__cell--slim o-grid__cell--flex o-grid__cell--center-h" *ngIf="!vm.isActiveCallState(vm.callState?.ENDED)">
									<button title="End call" class="c-button c-button--s8 c-button--icon c-button--round" (click)="vm.hangUpCall(false)">
										<i class="o-icon o-icon--hang-up u-no-mr" aria-hidden="true"></i>
									</button>
								</div>
							</div>
						</div>
						<div class="o-grid__cell u-no-p u-hidden@up-to-md"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<audio preload="auto" loop id="call_ringbacktone">
	<source src="https://dqs3afosyxqoy.cloudfront.net/assets/common/audio/call/ringbacktone.mp3" type="audio/mpeg" />
	<source src="https://dqs3afosyxqoy.cloudfront.net/assets/common/audio/call/ringbacktone.wav" type="audio/wav" />
</audio>
